import { Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useCallback, useEffect, useState } from "react";
import PagesContainer from "../../components/UI/PagesContainer";
import { useExtensionConfigs } from "../../hooks/useExtensionConfigs";
import { IExtensionConfig } from "../../models/extensions";
import { Extension } from "../../models/intalled-extensions";
import { useAppSelector } from "../../store/store";
import { TopMedInternalSchedButton } from "./TopMedInternalSchedButton/TopMedInternalSchedButton";
import { usePage } from "../../hooks/usePage";

const translationPath = "page.home.";

const ExternalCalendarButtonPage = () => {
  const { t } = useTranslation();

  const { pageTitle } = usePage();

  const [description, setDescription] = useState<IExtensionConfig>();

  const [googlePlayLink, setGooglePlayLink] = useState<IExtensionConfig>();

  const [appStoreLink, setAppStoreLink] = useState<IExtensionConfig>();

  const [actionLabelText, setActionLabelText] = useState<IExtensionConfig>();

  const [topMedDescription, setTopMedDescription] =
    useState<IExtensionConfig>();

  const [topMedGooglePlayLink, setTopMedGooglePlayLink] =
    useState<IExtensionConfig>();

  const [topMedAppStoreLink, setTopMedAppStoreLink] =
    useState<IExtensionConfig>();

  const [descriptionTopMedInternalSched, setDescriptionTopMedInternalSched] =
    useState<string | null>(null);

  const { mode } = useAppSelector((state) => state.theme);

  const { fetchExtensionConfig } = useExtensionConfigs();
  const fetchExtensions = useCallback(async () => {
    const configActionLabelText = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "ActionLabelText"
    );
    setActionLabelText(configActionLabelText);

    const configDescription = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "Description"
    );
    if (configDescription && configDescription.value.length > 1) {
      setDescription(configDescription);
    }

    const configGooglePlayLink = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "GooglePlayLink"
    );
    if (configGooglePlayLink && configGooglePlayLink.value.length > 1) {
      setGooglePlayLink(configGooglePlayLink);
    }

    const configAppStoreLink = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "AppStoreLink"
    );
    if (configAppStoreLink && configAppStoreLink.value.length > 1) {
      setAppStoreLink(configAppStoreLink);
    }

    const configTopMedDescription = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "TopMedDescription"
    );
    if (configTopMedDescription && configTopMedDescription.value.length > 1) {
      setTopMedDescription(configTopMedDescription);
    }

    const configTopMedGooglePlayLink = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "TopMedGooglePlayLink"
    );
    if (
      configTopMedGooglePlayLink &&
      configTopMedGooglePlayLink.value.length > 1
    ) {
      setTopMedGooglePlayLink(configTopMedGooglePlayLink);
    }

    const configTopMedAppStoreLink = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "TopMedAppStoreLink"
    );
    if (configTopMedAppStoreLink && configTopMedAppStoreLink.value.length > 1) {
      setTopMedAppStoreLink(configTopMedAppStoreLink);
    }

    const showTopMedInternalSched = await fetchExtensionConfig(
      Extension.EXTERNAL_CALENDAR_BUTTON,
      "ShowTopMedInternalSched"
    );

    if (showTopMedInternalSched && showTopMedInternalSched.value === "true") {
      const descriptionTopMedInternalSched = await fetchExtensionConfig(
        Extension.EXTERNAL_CALENDAR_BUTTON,
        "DescriptionTopMedInternalSched"
      );
      if (!descriptionTopMedInternalSched) return;
      setDescriptionTopMedInternalSched(descriptionTopMedInternalSched.value);
    }
  }, [fetchExtensionConfig]);

  useEffect(() => {
    fetchExtensions();
  }, [fetchExtensions]);

  return (
    <PagesContainer
      title={pageTitle || t(translationPath + actionLabelText?.value)}
    >
      <Stack spacing={1} alignItems="center" justifyContent="center">
        {topMedDescription && (
          <Typography sx={{ width: "100%", textAlign: "left" }}>
            {topMedDescription.value}
          </Typography>
        )}

        <Grid container spacing={2} justifyContent="center">
          {topMedGooglePlayLink && (
            <Grid item>
              <a
                href={topMedGooglePlayLink ? topMedGooglePlayLink.value : ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={
                    mode === "1" ? "/play_store_dark.png" : "/play_store.png"
                  }
                  alt={"play-store"}
                  style={{
                    width: 220,
                  }}
                />
              </a>
            </Grid>
          )}
          {topMedAppStoreLink && (
            <Grid item>
              <a
                href={topMedAppStoreLink ? topMedAppStoreLink.value : ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={mode === "1" ? "/app_store_dark.png" : "/app_store.png"}
                  alt={"app-store"}
                  style={{
                    width: 220,
                  }}
                />
              </a>
            </Grid>
          )}
        </Grid>

        {description && <Typography>{description.value}</Typography>}

        <Grid container spacing={2} justifyContent="center">
          {googlePlayLink && (
            <Grid item>
              <a
                href={googlePlayLink ? googlePlayLink.value : ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={
                    mode === "1" ? "/play_store_dark.png" : "/play_store.png"
                  }
                  alt={"play-store"}
                  style={{
                    width: 220,
                  }}
                />
              </a>
            </Grid>
          )}
          {appStoreLink && (
            <Grid item>
              <a
                href={appStoreLink ? appStoreLink.value : ""}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={mode === "1" ? "/app_store_dark.png" : "/app_store.png"}
                  alt={"app-store"}
                  style={{
                    width: 220,
                  }}
                />
              </a>
            </Grid>
          )}
          {descriptionTopMedInternalSched && (
            <TopMedInternalSchedButton
              description={descriptionTopMedInternalSched}
            />
          )}
        </Grid>
      </Stack>
    </PagesContainer>
  );
};

export default ExternalCalendarButtonPage;
